import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getAccountInfo } from '../../system/systemAction';
import './styles/styles.scss';
// import SliderCustom from './SliderCustom';
// import AboutDinogo from './AboutDinogo';
// import ServiceDinogo from './ServiceDinogo';
// import PromotionDinogo from './PromotionDinogo';
// import DownloadApp from './DownloadApp';
import ChatDinogo from './ChatDinogo';

const Home = (props) => {
  return (
    <>
      {/* <SliderCustom />
      <AboutDinogo />
      <ServiceDinogo />
      <PromotionDinogo />
      <DownloadApp /> */}
      <ChatDinogo />
    </>
  );
};
export default connect(
  (state) => ({
    // isLoading: state.system.isLoading
  }),
  { getAccountInfo }
)(withRouter(Home));
